// Route table. Three pages: /login, /, /hosts.
//
// Auth model: every protected page calls /api/v1/auth/me on mount; if the
// API returns 401 the page redirects to /login. Cookie auth is HttpOnly so
// JS can't peek at it directly — the /me round-trip IS our "am I logged in"
// signal. Trade-off: one extra request per page load. Acceptable for v0.
import { Route, Routes } from "react-router-dom";
import { LoginPage } from "./pages/LoginPage";
import { HomePage } from "./pages/HomePage";
import { HostsPage } from "./pages/HostsPage";

export function App() {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route path="/" element={<HomePage />} />
      <Route path="/hosts" element={<HostsPage />} />
    </Routes>
  );
}
